import { render, staticRenderFns } from "./IconCaution.vue?vue&type=template&id=6f2fe84c&scoped=true"
import script from "./IconCaution.vue?vue&type=script&lang=js"
export * from "./IconCaution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2fe84c",
  null
  
)

export default component.exports